import * as CONSTANTS from '../../constants';
import {clone} from "../../../services/ConverterService";
import { each, filter } from 'lodash-es';

export default {

    /**
     * Indicates that the contract overview is being fetched.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_PENDING] (state) {
        state.overview = {...state.overview, loading: true, error: false, noContent: false, items: undefined}
    },

    /**
     * Indicates that contract years has been successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_YEARS_SUCCESS] (state, payload) {
        state.overview = {...state.overview, loading: false, error: false, noContent: false, years: payload}
    },

    /**
     * Indicates that there are no contracts at all.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_YEARS_NO_CONTENT] (state) {
        state.overview = {...state.overview, loading: false, error: false, noContent: true, years: undefined}
    },

    /**
     * Indicates that the contract overview was fetched successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_SUCCESS] (state, payload) {
        state.overview = {...state.overview, loading: false, error: false, noContent: false, items: payload}
    },

    /**
     * Indicates that the contract overview was unsuccessfully fetched.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_FAILURE] (state) {
        state.overview = {...state.overview, loading: false, error: true, noContent: false, items: undefined}
    },

    /**
     * Indicates that the was no contracts for the overview.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_NO_CONTENT] (state) {
        state.overview = {...state.overview, loading: false, error: false, noContent: true, items: undefined}
    },

    /**
     * Set the filter for the contract overview list.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FILTER_SET] (state, payload) {
        state.overview.filter = payload;
    },

    /**
     * Contract list limit set.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_LIST_LIMIT_SET] (state, payload) {
        state.overview.limit = payload;
    },

    /**
     * Contract list year set.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_LIST_YEAR_SET] (state, payload) {
        state.overview.year = payload;
        state.overview.page = 1;
    },

    /**
     * Contract list page increment.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_LIST_PAGE_INCREMENT] (state) {
        state.overview.page++;
    },

    /**
     * Contract list page decrement.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_LIST_PAGE_DECREMENT] (state) {
        state.overview.page--;
    },

    /**
     * Contract list page reset.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_LIST_PAGE_RESET] (state) {
        state.overview.page = 1;
    },

    /**
     * Indicates that the contract data is being fetched.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_DATA_PENDING] (state) {
        state.contractManagement = {...state.contractManagement, loading: true, error: false, noContent: false, item: undefined};
    },

    /**
     * Indicates that the contract data was fetched successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_DATA_SUCCESS] (state, payload) {
        state.contractManagement = {...state.contractManagement, loading: false, error: false, noContent: false, item: payload.item};
        state.contractManagement.form = {...state.contractManagement.form, ...payload.form};
    },

    /**
     * Indicates that the contract data fetching was unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_DATA_FAILURE] (state) {
        state.contractManagement = {...state.contractManagement, loading: false, error: true, noContent: false, item: undefined};
    },

    /**
     * Indicates that the contract data fetch returned no content.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_DATA_NO_CONTENT] (state) {
        state.contractManagement = {...state.contractManagement, loading: false, error: false, noContent: true, item: false};
    },

    /**
     * Contract form set.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_SET] (state, payload) {
        if (payload.hasOwnProperty('files')) {
            state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ?
                state.contractManagement.form[payload.part][payload.subPart].files = payload.files :
                state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].files = payload.files;
        } else if (payload.hasOwnProperty('images')) {
            state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ?
                state.contractManagement.form[payload.part][payload.subPart].images = payload.images :
                state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].images = payload.images;
        } else if (payload.hasOwnProperty('text')) {
            state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ?
                state.contractManagement.form[payload.part][payload.subPart].text = payload.text :
                state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].text = payload.text;
        } else if (payload.hasOwnProperty('name')) {
            state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ?
                state.contractManagement.form[payload.part][payload.subPart].name = payload.name :
                state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].name = payload.name;
        } else if (payload.hasOwnProperty('site')) {
            state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].sites.push({name: payload.site.name, id: payload.site.id});
        } else if (payload.hasOwnProperty('item')) {
            state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].name = payload.item.name;
            state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].id = payload.item.id;
            // If chosen site or accommodation then set text to 'No Changes'
            if (payload.item.id) {
                state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].text = 'No changes';
            }
        } else if (payload.hasOwnProperty('show')) {
            state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].showInContract = payload.show;
        }
    },

    /**
     * Remove contract element from list.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_UNSET] (state, payload) {
        if (payload.hasOwnProperty('site')) {
            state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].sites.splice(payload.site, 1);
        }
    },

    /**
     * Set the form part.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_PART_SET] (state, payload) {
        state.contractManagement.form = {...state.contractManagement.form, ...payload};
    },

    /**
     * Contract form page forward.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_PAGE_SET] (state, payload) {
        state.contractManagement.form = {...state.contractManagement.form, ...payload};
    },

    /**
     * Indicates that the form is being saved.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_PENDING] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: true, error: false, noContent: false};
    },

    /**
     * Indicates that the form was saved.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_SUCCESS] (state, payload) {
        state.contractManagement.form = {...state.contractManagement.form, ...payload.form, loading: false, error: false, noContent: false};
        state.contractManagement.item = payload.item;
        state.contractManagement.form.index = 0;
    },

    /**
     * Indicates that the form was not saved.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the form didn't exist.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_NO_CONTENT] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false, noContent: true};
    },

    /**
     * Update the contract progress.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_PROGRESS_SET] (state, payload) {
        state.contractManagement.progress = {...state.contractManagement.progress, ...payload};
    },

    /**
     * Indicate that the file removal is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_PENDING] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: true, error: false, noContent: false};
    },
    /**
     * Indicate that the file removal was successful.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_SUCCESS] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false, noContent: false};
    },

    /**
     * Indicates that the file removal failed.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_FAILURE] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the file didn't exist.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_NO_CONTENT] (state, payload) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false, noContent: true};
        state.contractManagement.form[payload.part][payload.subPart].files = undefined;
        state.contractManagement.form[payload.part][payload.subPart].s3 = undefined;
    },

    /**
     * Indicate that the download of the file is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_PENDING] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: true, error: false, noContent: false};
    },

    /**
     * Indicates that the file was downloaded successfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_SUCCESS] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false, noContent: false}
    },

    /**
     * Indicates that the download failed.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_FAILURE] (state) {
        state.contractManagement.fomr = {...state.contractManagement.form, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the file was not found.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_NO_CONTENT] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false, noContent: true};
    },

    /**
     * Indicates that the email is being sent.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: true, error: false, noContent: false};
    },

    /**
     * Indicates that the email was send successfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false, noContent: false};
    },

    /**
     * Indicates that the email was send unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the email was send unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: true, noContent: true};
    },

    /**
     * Remove file from file list.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_REMOVE] (state, payload) {
        if(payload.type === 'files') {
            payload.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ?
                state.contractManagement.form[payload.part][payload.subPart].files.splice(payload.index, 1):
                state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].files.splice(payload.index, 1);
        } else {
            payload.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ?
                state.contractManagement.form[payload.part][payload.subPart].images.splice(payload.index, 1):
                state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].images.splice(payload.index, 1);
        }
    },

    /**
     * Add new default object.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_ELEMENT_ADD] (state) {
        state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].push(
            {...clone(state.contractManagement.form.defaults[state.contractManagement.form.part][state.contractManagement.form.subPart]), sites: []}
        );
        state.contractManagement.form.index = state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].length - 1;
    },

    /**
     * Remove element.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_ELEMENT_REMOVE] (state, payload) {
        // If removing a site then ensure that all accommodations sites arrays are updated accordingly
        if (state.contractManagement.form.subPart === 'siteInfo') {
            const siteName = state.contractManagement.form.extended.siteInfo[payload].name;
            each(state.contractManagement.form['extended']['accInfo'], accommodation => {
                accommodation.sites = filter(accommodation.sites, site => {
                    return site.name !== siteName
                })
            });
            state.contractManagement.form.extended.accInfo = filter(state.contractManagement.form.extended.accInfo, accommodation => {
                return accommodation.sites.length;
            });
        }
        state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].splice(payload, 1);
        // If last element is removed then replace with default element
        if (state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].length === 0) {
            state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].push(
                clone(state.contractManagement.form.defaults[state.contractManagement.form.part][state.contractManagement.form.subPart])
            )
        } else {
            if (payload <= state.contractManagement.form.index && state.contractManagement.form.index > 0) {
                state.contractManagement.form.index--;
            }
        }
    },

    /**
     * Set the contract form index.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_INDEX_SET] (state, payload) {
        state.contractManagement.form.index = payload;
    },

    /**
     * Reset the contract form index.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_FORM_INDEX_RESET] (state) {
        state.contractManagement.form.index = 0;
    },

    /**
     * Indicates that the contract supplier data is being fetched.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_PENDING] (state) {
        state.contractManagement.supplier = {...state.contractManagement.supplier, loading: true, error: false, noContent: false, items: {sites: [], accommodations: []}};
    },

    /**
     * Indicates that the contract supplier data was fetched successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_SUCCESS] (state, payload) {
        state.contractManagement.supplier = {...state.contractManagement.supplier, loading: false, error: false, noContent: false, items: payload}
    },

    /**
     * Indicates that the contract supplier data was fetched unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_FAILURE] (state) {
        state.contractManagement.supplier = {...state.contractManagement.supplier, loading: false, error: true, noContent: false, items: {sites: [], accommodations: []}};
    },

    /**
     * Indicates that the contract supplier data had no results.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_NO_CONTENT] (state) {
        state.contractManagement.supplier = {...state.contractManagement.supplier, loading: false, error: false, noContent: true, items: {sites: [], accommodations: []}};
    },

    /**
     * Set the default text to no changes to indicate that nothing changed.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_NO_CHANGES_SET] (state, payload) {
        state.contractManagement.form[payload.part][payload.subPart].text = payload.text;
    },

    /**
     * Indicate that the supplier contract is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DATA_PENDING] (state) {
        state.contract = {...state.contract, loading: true, error: false, noContent: false, productError: false, item: undefined};
    },

    /**
     * Indicate that the supplier contract was successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_DATA_SUCCESS] (state, payload) {
        state.contract = {...state.contract, loading: false, error: false, noContent: false, productError: false, item: payload};
    },

    /**
     * Indicates that the supplier contract was unsuccessfully fetched.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DATA_FAILURE] (state) {
        state.contract = {...state.contract, loading: false, error: true, noContent: false, productError: false, item: undefined};
    },

    /**
     * Indicates that the contract was unsuccessfully fetched due to unknown product type.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DATA_PRODUCT_ERROR] (state) {
        state.contract = {...state.contract, loading: false, error: true, noContent: false, productError: true, item: undefined};
    },

    /**
     * Indicates that the supplier contract returned no content.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DATA_NO_CONTENT] (state) {
        state.contract = {...state.contract, loading: false, error: false, noContent: true, item: undefined};
    },

    /**
     * Indicates that the contract history is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_HISTORY_PENDING] (state) {
        state.history = {...state.history, loading: true, error: false, noContent: false, items: undefined};
    },

    /**
     * Indicates that the contract history was successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_HISTORY_SUCCESS] (state, payload) {
        state.history = {...state.history, loading: false, error: false, noContent: false, items: payload};
    },

    /**
     * Indicates that the contract history was unsuccessfully fetched.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_HISTORY_FAILURE] (state) {
        state.history = {...state.history, loading: false, error: true, noContent: false, items: undefined}
    },

    /**
     * Indicates that the contract history returned no content.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_HISTORY_NO_CONTENT] (state) {
        state.history = {...state.history, loading: false, error: false, noContent: true, items: undefined}
    },

    /**
     * Set the contract part.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_FORM_PART_SET] (state, payload) {
        state.contract.part = payload.part;
    },

    /**
     * Indicates that the accept part is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_FORM_PART_ACCEPT_PENDING] (state) {
        state.contract.progress.accept = {...state.contract.progress.accept, loading: true, error: false}
    },

    /**
     * Indicate that the accept part was successful.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_FORM_PART_ACCEPT_SUCCESS] (state) {
        state.contract.progress.accept = {...state.contract.progress.accept, loading: false, error: false}
    },

    /**
     * Indicate that the accept part was unsuccessful.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_FORM_PART_ACCEPT_FAILURE] (state) {
        state.contract.progress.accept = {...state.contract.progress.accept, loading: false, error: true}
    },

    /**
     * Set the notes in the contract form part.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_FORM_NOTES_SET] (state, payload) {
        state.contract.form.item[payload.part].note = payload.note;
    },

    /**
     * Indicate that the contract form save is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_FORM_SAVE_PENDING] (state) {
        state.contract.form = {...state.contract.form, loading: true, error: false};
    },

    /**
     * Indicates that the form was saved successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_FORM_SAVE_SUCCESS] (state, payload) {
        state.contract.form = {...state.contract.form, loading: false, error: false, item: payload.item};
        state.contract.progress.item = {...state.contract.progress.item, ...payload.clone};
    },

    /**
     * Indicates that the form was saved successfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_FORM_SAVE_FAILURE] (state) {
        state.contract.form = {...state.contract.form, loading: false, error: true, item: undefined};
    },

    /**
     * Indicates that the notes are pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTES_PENDING] (state) {
        state.contract.notes = {...state.contract.notes, loading: true, error: false, noCOntent: false}
    },

    /**
     * Indicates that the notes was fetched successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_NOTES_SUCCESS] (state, payload) {
        state.contract.notes = {...state.contract.notes, loading: false, error: false, noContent: false, item: payload};
    },

    /**
     * Inidactes that the notes was fetched unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTES_FAILURE] (state) {
        state.contract.notes = {...state.contract.notes, loading: false, error: true, noContent: false}
    },

    /**
     * Indicates that there were no notes fetched for this contract.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTES_NO_CONTENT] (state) {
        state.contract.notes = {...state.contract.notes, loading: false, error: false, noContent: true, item: undefined}
    },

    /**
     * Indicates that the ready for review is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_PENDING] (state) {
        state.contractManagement = {...state.contractManagement, loading: true, error: false};
    },

    /**
     * Inidcates that the ready for review was successful.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_SUCCESS] (state) {
        state.contractManagement = {...state.contractManagement, loading: false, error: false};
    },

    /**
     * Indicatest that the ready for review was unsuccessful.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_FAILURE] (state) {
        state.contractManagement = {...state.contractManagement, loading: false, error: true};
    },

    /**
     * Indicates that the contract is being finished
     * @param state
     */
    [CONSTANTS.CONTRACT_FINISH_PENDING] (state) {
        state.contract.finish = {...state.contract.finish, loading: true, error: false, noContent: false}
    },

    /**
     * Indicates that the contract was finished successfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_FINISH_SUCCESS] (state) {
        state.contract.finish = {...state.contract.finish, loading: false, error: false, noContent: false}
    },

    /**
     * Indicates that the contract was unsuccessfully finished.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_FINISH_FAILURE] (state) {
        state.contract.finish = {...state.contract.finish, loading: false, error: true, noContent: false}
    },

    /**
     * Indicates that the contract did not exist.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_FINISH_NO_CONTENT] (state) {
        state.contract.finish = {...state.contract.finish, loading: false, error: false, noContent: true}
    },

    /**
     * Indicates that the contract is being downloaded.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DOWNLOAD_PENDING] (state) {
        state.contract.download = {...state.contract.download, loading: true, error: false};
    },

    /**
     * Indicates that the contract was downloaded.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DOWNLOAD_SUCCESS] (state) {
        state.contract.download = {...state.contract.download, loading: false, error: false};
    },

    /**
     * Indicates that the contract was not downloaded.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DOWNLOAD_FAILURE] (state) {
        state.contract.download = {...state.contract.download, loading: false, error: true};
    },

    /**
     * Trying to fetch brands.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_PENDING] (state) {
        state.contractManagement.brands = {...state.contractManagement.brands, brands: undefined, loading: true, noContent: false, error: false}
    },

    /**
     *
     * Successful fetching of brands.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_SUCCESS] (state, payload) {
        state.contractManagement.brands = {...state.contractManagement.brands, brands: payload, loading: false, noContent: false, error: false}
    },

    /**
     * No brands found.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_NO_CONTENT] (state) {
        state.contractManagement.brands = {...state.contractManagement.brands, brands: undefined, loading: false, noContent: true, error: false}
    },

    /**
     * Failed to fetch brands.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_FAILURE] (state) {
        state.contractManagement.brands = {...state.contractManagement.brands, brands: undefined, loading: false, noContent: false, error: true}
    },

    /**
     * Add a brand to internal list of brands to use.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_ADD_BRAND] (state, payload) {
        state.contractManagement.form.extended.brands = [...state.contractManagement.form.extended.brands, payload]
    },

    /**
     * Remove a brand from internal list of brands to use.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_REMOVE_BRAND] (state, payload) {
        state.contractManagement.form.extended.brands = [...state.contractManagement.form.extended.brands.filter((item, index) => index !== payload)]
    },

    /**
     * Initiates a get existing sites or accommodations for a supplier.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_PENDING] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: true, error: false}
    },

    /**
     * Successfully fetched sites for copying.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_SITE_SUCCESS] (state, payload) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false};
        state.contractManagement.form.extended = {...state.contractManagement.form.extended, siteInfo: payload}
    },

    /**
     * Successfully fetched accommodations for copying.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_ACCOMMODATION_SUCCESS] (state, payload) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false};
        state.contractManagement.form.extended = {...state.contractManagement.form.extended, accInfo: payload}
    },

    /**
     * Failed to fetch either sites or accommodations for copying.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false}
    },

    /**
     * Failed to fetch either sites or accommodations for copying.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE] (state) {
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: true}
    },

    /**
     * Reset contract management state.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_RESET_STATE] (state) {
        state.contractManagement = {...state.contractManagement, loading: false, error: false, noContent: false};
        state.contractManagement.supplier = {...state.contractManagement.supplier, loading: false, error: false, noContent: false};
        state.contractManagement.supplier.items = {...state.contractManagement.supplier.items, siteInfo: [], accInfo: []};
        state.contractManagement.progress.basic = {...state.contractManagement.progress.basic,  priceExtra: false, allotmentRules: false, arrivalRules: false, commission: false, discounts: false, notes: false};
        state.contractManagement.progress.extended = {...state.contractManagement.progress.extended, siteInfo: false, accInfo: false, arrivalDeparture: false, brands: false};
        state.contractManagement.form = {...state.contractManagement.form, loading: false, error: false, noContent: false, index: 0};
        state.contractManagement.form.defaults.basic = {...state.contractManagement.form.defaults.basic, text: undefined, files: [], s3: []};
        state.contractManagement.form.defaults.extended.accInfo = {...state.contractManagement.form.defaults.extended.accInfo, entityId: undefined, name: undefined, id: undefined, text: undefined, files: [], images: [], s3: [], imagesS3: [], sites: []};
        state.contractManagement.form.defaults.extended.siteInfo = {...state.contractManagement.form.defaults.extended.siteInfo, showInContract: true, entityId: undefined, name: undefined, id: undefined, text:undefined, area: undefined, files: [], images: [], s3: [], imagesS3: []};
        state.contractManagement.form.defaults.extended.arrivalDeparture = {...state.contractManagement.form.defaults.extended.arrivalDeparture, text: undefined, files: [], s3: []};
        state.contractManagement.form.defaults.extended.brands = {...state.contractManagement.form.defaults.extended.brands, brands: []};
        state.contractManagement.brands = {...state.contractManagement.brands, brands: [], noContent: false, error: false, loading: false};
    },

    /**
     * Set the contract note object.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_NOTE_SET] (state, payload) {
        state.contract.note.item = {...state.contract.note.item, ...payload}
    },

    /**
     * Indicate that the create note is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTE_CREATE_PENDING] (state) {
        state.contract.note = {...state.contract.note, loading: true, error: false}
    },

    /**
     * Indicate that the create note was successful.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTE_CREATE_SUCCESS] (state) {
        state.contract.note = {...state.contract.note, loading: false, error: false}
        state.contract.note.item.note = "";
    },

    /**
     * Indicates that the create not was unsuccessful.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTE_CREATE_FAILURE] (state) {
        state.contract.note = {...state.contract.note, loading: false, error: true}
    },

    /**
     * Indicates that the contract accepted parts are being fetched.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_ACCEPT_LIST_PENDING] (state) {
        state.contract.progress = {...state.contract.progress, loading: true, error: false}
    },

    /**
     * Indicates that the contract accepted parts was fetched successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_ACCEPT_LIST_SUCCESS] (state, payload) {
        state.contract.progress = {...state.contract.progress, loading: false, error: false, item: payload}
    },

    /**
     * Indicates that the contract accepted parts was fetched unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_ACCEPT_LIST_FAILURE] (state) {
        state.contract.progress = {...state.contract.progress, loading: false, error: true}
    },

    /**
     * Indicates that the notification email is being sent.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTE_EMAIL_PENDING] (state) {
        state.contract.email = {...state.contract.email, loading: true, error: false}
    },

    /**
     * Indicates that the notification email was sent successfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTE_EMAIL_SUCCESS] (state) {
        state.contract.email = {...state.contract.email, loading: false, error: false}
    },

    /**
     * Indicates that the notification email was sent unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_NOTE_EMAIL_FAILURE] (state) {
        state.contract.email = {...state.contract.email, loading: false, error: true}
    },

    /**
     * Set the show mine or all filter.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_LIST_SHOW_SET] (state, payload) {
        state.overview.show = payload;
    },

    /**
     * Indicates that the contract draft is pending.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DRAFT_PENDING] (state) {
        state.draft = {...state.draft, loading: true, error: false, item: null}
    },

    /**
     * Indicates that the contract draft was fetched successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_DRAFT_SUCCESS] (state, payload) {
        state.draft = {...state.draft, loading: false, error: false, item: payload}
    },

    /**
     * Indicates that the contract draft was fetched unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.CONTRACT_DRAFT_FAILURE] (state) {
        state.draft = {...state.draft, loading: false, error: true, item: null}
    },

    /**
     * Set the search object in state.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CONTRACT_MANAGEMENT_LIST_SEARCH_SET] (state, payload) {
        state.overview.search = payload;
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/contract/mutations.js